import request from '@/libs/request'

// 平台用户列表
export function booklist (data) {
  return request({
    url: `bookVideo/list`,
    method: 'get',
    params: data
  })
}
export function bookInfo (id) {
  return request({
    url: `bookVideo/info/${id}`,
    method: 'get'
  })
}
// 启用禁用用户
export function changeStatus (id) {
  return request({
    url: `bookVideo/changeStatus/${id}`,
    method: 'post'
  })
}
export function getCate () {
  return request({
    url: `bookVideo/getCate`,
    method: 'get'
  })
}
export function addBooks (data) {
  return request({
    url: `bookVideo/info`,
    method: 'post',
    data
  })
}
export function delBook (id) {
  return request({
    url: `bookVideo/list/${id}`,
    method: 'delete'
  })
}

